import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchListItemMetadata'

export default defineMessages({
  preferredVendorLabel: {
    id: `${scope}.preferredVendorLabel`,
    defaultMessage: 'Preferred vendor',
  },
  identifierAndDateLabel: {
    id: `${scope}.identifierAndDateLabel`,
    defaultMessage: '{identifier} • {date}',
  },
})
